<template>
  <div>
    <v-dialog
        v-model="value"
        scrollable
        @click:outside="fecharModalClickOutside"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card class="card-component">
        <v-card-title class="primary modal-title" primary-title>
          Verificação de informações obrigatórias
        </v-card-title>
        <v-card-text style="color: black" class="pt-3">
          <div v-if="camposNaoPreenchidos.length > 0" v-for="(item, index) in camposNaoPreenchidos" :key="index" class="campo-nao-preenchido-info">
            <v-icon color="red" class="mr-2">error_outline</v-icon><span>{{ item.mensagem }}</span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="fechar" text depressed color="primary">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ModalCamposNaoPreenchido',
  props: {
    value: Boolean,
    persistencia: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: Number,
      default: 400
    },
    camposNaoPreenchidos: Array
  },
  methods: {
    fecharModalClickOutside() {
      if (!this.persistencia) {
        this.fechar()
      }
    },
    fechar() {
      this.$emit('modalCamposNaoPreenchidoAcaoFechar')
    },
  }

}
</script>

<style scoped lang="stylus">
.card-component
  text-align start

.campo-nao-preenchido-info
  display flex
  align-items center
  margin-bottom 10px
  color #77797B

</style>
